(function ($) {
    'use strict';
    $.fn.backTop = function (options) {
        return this.each(function () {
			const self = $(this)[0];
			const cta = self.querySelector( 'a' );
			const target = document.querySelector( cta.getAttribute( 'href' ) );
			const $window = $(window);
			const firstLoad = true;

			var settings = $.extend({
				breakpoint: parseInt( Revealizr.breakpointMobileMaxWidth ),
				destroy: false
            }, options );

			const init = function() {
				const targetPosition = $(target).offset().top;
				const container = self.parentElement;
				const containerHeight = container.clientHeight;
				const containerBottom = containerHeight + $(container).offset().top;
				const selfPosition = $(self).offset().top;
				const minimumPaddingBetweenCtaAndContainer = 20;
				const startPosition = window.innerHeight + targetPosition;
				
                if ( containerBottom > startPosition ) {
					self.classList.add( 'is_active' );
					self.style.setProperty( 'padding-top', `${ Math.max( minimumPaddingBetweenCtaAndContainer, ( startPosition - selfPosition ) + minimumPaddingBetweenCtaAndContainer ) }px` );
                }
			};

			const destroy = function() {
				self.style.removeProperty( 'padding-top' );
				self.classList.remove( 'is_active' );
			};

			const initDestroy = function() {
				if( window.innerWidth >= settings.breakpoint && settings.destroy === false ) {
					init();
				} else if( firstLoad || settings.destroy === true ) {
					destroy();
				}
			};

			initDestroy();
			
			const scrollHandler_trigger = _.throttle(initDestroy, 50);
			$window.on(`resize.backTop`,  scrollHandler_trigger);
        });
    }
})(jQuery);
